import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/v1/public/app-config/`;

export const NOMBRE_POR_OMISION = 'SoftecPY-POS';

/*
 * El nombre del sistema se configura desde el panel de plataforma, así que no
 * puede estar escrito en el código: estaba repetido en cinco pantallas, y
 * cambiarlo en Configuración Global solo surtía efecto en dos de ellas. El
 * resto seguía mostrando el nombre viejo, que es la peor forma de tener una
 * opción de configuración: existe, se puede cambiar, y no hace lo que dice.
 *
 * La respuesta se guarda en memoria del módulo. Todas las pantallas lo piden
 * —login, landing, barra lateral— y sin esto cada una abriría su propia
 * consulta en cada montaje.
 */
let enMemoria = null;
let enVuelo = null;

function pedirNombre() {
  if (enMemoria !== null) return Promise.resolve(enMemoria);
  if (enVuelo) return enVuelo;

  enVuelo = axios.get(API)
    .then(r => {
      enMemoria = r.data?.app_name || NOMBRE_POR_OMISION;
      return enMemoria;
    })
    .catch(() => {
      // Que no se pueda leer la configuración no debe dejar la pantalla sin
      // título: se usa el nombre por omisión y se reintenta en el próximo
      // montaje, por si fue una caída pasajera.
      enVuelo = null;
      return NOMBRE_POR_OMISION;
    });

  return enVuelo;
}

export function useNombreApp() {
  const [nombre, setNombre] = useState(enMemoria || NOMBRE_POR_OMISION);

  useEffect(() => {
    let vigente = true;
    pedirNombre().then(n => { if (vigente) setNombre(n); });
    return () => { vigente = false; };
  }, []);

  return nombre;
}

/** Olvida el nombre guardado. Se usa al guardarlo en Configuración Global. */
export function olvidarNombreApp() {
  enMemoria = null;
  enVuelo = null;
}
